function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, MenuItem, Glyphicon } from 'react-bootstrap';
import './ArticleSourceSelector.scss';
import { getSourceColor } from '../utils/knreise';

var ArticleSourceSelector = function (_React$Component) {
  _inherits(ArticleSourceSelector, _React$Component);

  function ArticleSourceSelector() {
    _classCallCheck(this, ArticleSourceSelector);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.state = {
      expanded: false
    };
    return _this;
  }

  ArticleSourceSelector.prototype.toggleSource = function toggleSource(source) {
    var _props = this.props,
        activeSources = _props.activeSources,
        onSelect = _props.onSelect;
    var idx = activeSources.indexOf(source.dataIndex);
    this.didJustSetSource = true;

    if (idx === -1) {
      var newSources = Array.from(activeSources);
      newSources.push(source.dataIndex);
      onSelect(newSources);
    } else if (activeSources.length > 1) {
      var _newSources = Array.from(activeSources);

      _newSources.splice(idx, 1);

      onSelect(_newSources);
    }
  };

  ArticleSourceSelector.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        sources = _props2.sources,
        activeSources = _props2.activeSources,
        className = _props2.className,
        placeholder = _props2.placeholder;
    var expanded = this.state.expanded;
    var activeSourcesTitle = activeSources.map(function (source) {
      return sources.find(function (s) {
        return s.dataIndex === source;
      }).text;
    }).join(', ');
    var title = placeholder ? React.createElement('span', null, placeholder(activeSources.length, activeSourcesTitle)) : React.createElement('span', null, activeSourcesTitle);
    return React.createElement('div', {
      className: ['article-sources', className || ''].join(' ')
    }, React.createElement(DropdownButton, {
      id: 'articleSourceSelector',
      bsStyle: 'primary',
      open: expanded,
      onToggle: function onToggle(isOpen) {
        if (_this2.didJustSetSource) {
          _this2.didJustSetSource = false;
          return;
        }

        _this2.setState({
          expanded: isOpen
        });
      },
      title: title
    }, sources.map(function (source) {
      return React.createElement(MenuItem, {
        key: source.dataIndex,
        className: 'article-sources--item',
        onSelect: function onSelect() {
          return _this2.toggleSource(source);
        }
      }, React.createElement(Glyphicon, {
        glyph: 'stop',
        className: 'pull-right',
        style: {
          color: getSourceColor(source)
        }
      }), React.createElement(Glyphicon, {
        glyph: 'ok',
        className: activeSources.indexOf(source.dataIndex) === -1 ? 'hide' : ''
      }), React.createElement('span', null, source.text));
    })));
  };

  return ArticleSourceSelector;
}(React.Component);

export { ArticleSourceSelector as default };
ArticleSourceSelector.propTypes = process.env.NODE_ENV !== "production" ? {
  sources: PropTypes.array.isRequired,
  className: PropTypes.string,
  activeSources: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.func
} : {};